export default {
  formSelectLabel: {
    id: 'product_comparison_form_select_label',
    defaultMessage: 'Selected product',
  },
} as const
